const MP_NAVIGATE_SLIDE = 'MP_NAVIGATE_SLIDE'

/**
 * Jump from one slide to another. The deck harness only accepts single step
 * navigation messages, so an absolute jump is sent as a run of steps in the
 * right direction.
 */
export function goToSlide(fromIndex: number, toIndex: number): void {
  const delta = toIndex - fromIndex
  if (delta === 0) return
  const direction = delta > 0 ? 'next' : 'prev'
  for (let step = 0; step < Math.abs(delta); step += 1) {
    window.postMessage({ type: MP_NAVIGATE_SLIDE, direction }, '*')
  }
}
